"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _A = _interopRequireDefault(require("../A"));

var _RichTypography = _interopRequireDefault(require("../RichTypography"));

var _excluded = ["support", "socialMedia", "title"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {},
    title: _defineProperty({
      textAlign: "center"
    }, theme.breakpoints.up("md"), {
      textAlign: "left"
    }),
    icon: {
      width: "1.375rem",
      height: "1.375rem",
      objectFit: "contain"
    },
    link: {
      display: "inline-block",
      padding: "0 0.625rem"
    },
    links: _defineProperty({
      "& > a": {
        display: "inline-block",
        borderRight: "1px solid white"
      },
      "& > a:last-of-type": {
        border: "none"
      }
    }, theme.breakpoints.up("md"), {
      justifyContent: "flex-start",
      width: "auto"
    }),
    text: {}
  };
});

function StayInTouch(_ref) {
  var support = _ref.support,
      socialMedia = _ref.socialMedia,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles(props);

  if (!(socialMedia && socialMedia.length)) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    className: classes.root
  }, title && /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: "auto",
    className: classes.title
  }, /*#__PURE__*/_react["default"].createElement(_RichTypography["default"], {
    className: (0, _clsx["default"])(classes.text)
  }, title)), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: "auto",
    container: true,
    className: classes.links
  }, support && /*#__PURE__*/_react["default"].createElement(_A["default"], {
    href: "mailto:".concat(support.email),
    className: (0, _clsx["default"])(classes.link, classes.supportLink)
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: support.image.url,
    alt: support.image.alt,
    className: (0, _clsx["default"])(classes.icon, classes.supportIcon)
  })), socialMedia.map(function (media) {
    return /*#__PURE__*/_react["default"].createElement(_A["default"], {
      key: media.url,
      href: media.url,
      className: (0, _clsx["default"])(classes.link, classes.socialLink)
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: media.image.url,
      alt: media.image.alt,
      className: (0, _clsx["default"])(classes.icon, classes.socialIcon)
    }));
  })));
}

StayInTouch.propTypes = {
  socialMedia: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    url: _propTypes["default"].string.isRequired,
    image: _propTypes["default"].shape({
      url: _propTypes["default"].string.isRequired,
      alt: _propTypes["default"].string.isRequired
    }).isRequired
  }).isRequired).isRequired,
  support: _propTypes["default"].shape({
    email: _propTypes["default"].string.isRequired,
    image: _propTypes["default"].shape({
      url: _propTypes["default"].string.isRequired,
      alt: _propTypes["default"].string.isRequired
    }).isRequired
  }),
  title: _propTypes["default"].string
};
StayInTouch.defaultProps = {
  support: undefined,
  title: "Stay in touch with us @ &nbsp;"
};
var _default = StayInTouch;
exports["default"] = _default;